var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-h1Block__breadCrumb",attrs:{"id":"vue_block_breadcrumbs"}},[_c('BreadcrumbsView',{attrs:{"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }